import { TIENDA_HANDY } from "config";

// Configuraciones de marca específicas
export const BRAND_CONFIGS = {
  handy: {
    title: "Handy - Dashboard Administración",
    description: "Comience a aumentar sus ventas con Handy.",
    favicon: "/handy-favicon-light.png",
    faviconDark: "/handy-favicon-dark.png",
    siteName: "handy.io",
    url: "https://handy.io/",
    ogImage: "https://handy.io/og-image/og-facebook.png",
    twitterImage: "https://handy.io/og-image/og-twitter.png",
    themeColor: "#2296f3",
    brandDescription: "Handy administración, la mejor forma de vender tus productos",
  },
  rhino: {
    title: "Rhino - Dashboard Administración",
    description: "Comience a aumentar sus ventas con Rhino.",
    favicon: "/favicon.png",
    faviconDark: "/favicon.png",
    siteName: "rhinox.io",
    url: "https://rhinox.io/",
    ogImage: "https://rhinox.io/og-image/og-facebook.png",
    twitterImage: "https://rhinox.io/og-image/og-twitter.png",
    themeColor: "#2296f3",
    brandDescription: "Rhino administración, la mejor forma de vender tus productos",
  },
};

/**
 * Obtiene la configuración de marca actual basada en TIENDA_HANDY
 * @returns {Object} Configuración de marca actual
 */
export const getCurrentBrandConfig = () => {
  return TIENDA_HANDY ? BRAND_CONFIGS.handy : BRAND_CONFIGS.rhino;
};

/**
 * Obtiene el nombre de la marca actual
 * @returns {string} Nombre de la marca
 */
export const getBrandName = () => {
  return TIENDA_HANDY ? "Handy" : "Rhino";
};

/**
 * Obtiene la URL base de la marca actual
 * @returns {string} URL base
 */
export const getBrandUrl = () => {
  const config = getCurrentBrandConfig();
  return config.url;
};

/**
 * Obtiene el sitio web de la marca actual
 * @returns {string} Nombre del sitio
 */
export const getBrandSiteName = () => {
  const config = getCurrentBrandConfig();
  return config.siteName;
};

/**
 * Obtiene el favicon apropiado basado en el tema (claro/oscuro)
 * @param {boolean} isDarkMode - Si el tema actual es oscuro
 * @returns {string} URL del favicon
 */
export const getFaviconForTheme = (isDarkMode = false) => {
  const config = getCurrentBrandConfig();
  return isDarkMode && config.faviconDark ? config.faviconDark : config.favicon;
};
